import { Route } from "react-router-dom";
import React from "react";
import AuthWrapper from "./AuthWrapper";


const getRoutes = (allRoutes) =>
  allRoutes.map(({ path, key, page, private: isPrivate }) => {
    const Element = isPrivate
      ? <AuthWrapper>{page}</AuthWrapper>
      : page;

    return <Route path={path} element={Element} key={key} />;
  });

export default getRoutes;